exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-ef6d170c]{text-align:center}h2[data-v-ef6d170c]{margin-bottom:20px}.paragraph[data-v-ef6d170c]{padding:20px;max-width:800px;text-align:left;margin:auto;font-size:20px;line-height:160%}#animated-logo[data-v-ef6d170c]{width:160px;margin:30px}#galshir-avatar[data-v-ef6d170c]{width:180px;border-radius:100px;margin:30px}.paragraph a[data-v-ef6d170c]{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ef6d170c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/About.vue
// module id = 61
// module chunks = 0